import { SkeletonLoader } from '@design';
import clsx from 'clsx';
import React from 'react';

import { getChartLoadingHeight } from '../../utils/simple-chart-utils';
import styles from './ChartLoading.module.scss';

interface ChartLoadingProps {
  isLegacyVariant: boolean;
  isChatMessage: boolean;
  className?: string;
}

export const ChartLoading = ({
  isLegacyVariant,
  isChatMessage,
  className,
}: ChartLoadingProps) => {
  return (
    <div
      data-testid="chart-loading"
      className={clsx(styles.skeletonWrapper, className)}
    >
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '100%',
              height: getChartLoadingHeight(isChatMessage, isLegacyVariant),
            },
          },
        ]}
      />
    </div>
  );
};
